import React from "react";
import { IMAGES } from "../src/config";
export function Footer() {
  return <footer className="w-full border-t border-white/5 bg-[#08081a] py-10" data-id="element-107" data-mp="3gezdb400vr15">
      <div className="mx-auto max-w-5xl px-4 text-center sm:px-6" data-id="element-108" data-mp="3gh3q6bfwg0dk">
        <img src={IMAGES.logo} alt="Nexto Digital" className="mx-auto h-8 w-auto object-contain" style={{
        maxWidth: 140
      }} data-id="element-109" data-mp="32p5qer82vgu2" />
        <p className="mx-auto mt-4 max-w-2xl text-xs leading-relaxed text-slate-500" data-id="element-110" data-mp="3uesa9h2573hk">
          Los resultados descritos no están garantizados y dependen del esfuerzo y
          la aplicación individual. Este producto es de carácter educativo. Nexto
          Digital no está afiliado a LinkedIn, ChatGPT ni a ninguna plataforma
          mencionada.
        </p>
        <div className="mt-5 flex flex-wrap items-center justify-center gap-4 text-xs text-slate-500" data-id="element-111" data-mp="3qf9nsguoakcm">
          <a href="#" className="hover:text-slate-300" data-id="element-112" data-mp="2ey9yzv7jannc">Términos</a>
          <a href="#" className="hover:text-slate-300" data-id="element-113" data-mp="2ezl3xycpu1g1">Privacidad</a>
          <a href="#" className="hover:text-slate-300" data-id="element-114" data-mp="3lalgthavm9v0">Contacto</a>
        </div>
        <p className="mt-5 text-xs text-slate-600" data-id="element-115" data-mp="3gaz376r4yrlo">
          © {new Date().getFullYear()} Nexto Digital, Inc. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}